;(function(window, document, $) {
  'use strict';

  /* Common functions */

  var device = function() {
    if (window.addEventListener)
      return 'ontouchstart' in window ? 'touchstart' : 'click';
    else return 'click';
  };

  /* Common variables */

  var mainNav = document.getElementById('js-main-nav'),
    deviceMenuBtn = document.getElementById('js-menu-btn');

  /* Setup on load */

  if (mainNav)
    mainNav.setAttribute('data-state', 'closed'); // Close the navigation on load (will remain open for non-js)

  /* Toggle menu */

  var toggleNavigation = function(e) {
    e.preventDefault();
    var state =
      mainNav.getAttribute('data-state') === 'open' ? 'closed' : 'open';
    mainNav.setAttribute('data-state', state);
    this.setAttribute('data-state', state);
  };

  $(deviceMenuBtn).on(device(), toggleNavigation);

  window.createCookie = function(name, value, days) {
    var expires = "";
    
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }

    document.cookie = name + "=" + value + expires + ";domain=geckoboard.com;path=/";
  };

  window.readCookie = function(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  window.eraseCookie = function(name) {
    window.createCookie(name, '', -1);
  };
})(window, document, jQuery);
